import { Analytics as DubAnalytics } from "@dub/analytics/react";

export const DubAnalyticsProvider = () => (
    <DubAnalytics
        domainsConfig={{
            refer: "refer.kick.co", // Your short domain for referral tracking
        }}
        cookieOptions={{
            expiresInDays: 30, // 30-day attribution window
        }}
        attributionModel="last-click"
    />
);
